import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModuleEventAttendance } from './module-event-attendance.model';

export class ModuleEventAttendanceStateModel extends EntityStateModel<ModuleEventAttendance> {}
